import React from 'react';
import { Warning } from '@jbhi-fi/lanyard-ui/components/Icons';
import { palette } from '@jbhi-fi/lanyard-ui/themes';
import { MarkdownBlock } from '../../MarkdownBlock';
import { styles } from './TimestampedAlert.css';

export type TimestampedAlertProps = {
  heading?: string;
  timestamp: string;
  content?: string;
};

type HeadingProps = {
  heading: string;
  timestamp: string;
};

const Heading = ({ heading, timestamp }: HeadingProps) => {
  return (
    <div className={styles.heading}>
      <div data-testid="jbalert-heading">{heading}</div>
      <div className={styles.timestamp} data-test-id="jbalert-timestamp">
        {timestamp}
      </div>
    </div>
  );
};

export const TimestampedAlert = ({ heading, timestamp, content }: TimestampedAlertProps) => {
  return (
    <div className={styles.container}>
      <div className={styles.leftContainer}>
        <Warning color={palette.warning.main} className={styles.icon} />
      </div>

      <div className={styles.content}>
        <Heading heading={heading || ''} timestamp={timestamp} />
        <div role="paragraph" className={styles.messaging}>
          <MarkdownBlock shouldLinkOpenInNewTab>{content || ''}</MarkdownBlock>
        </div>
      </div>
    </div>
  );
};
